import React from 'react';

const EuroIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6667 3.67927C11.6784 2.83974 10.3983 2.33325 9 2.33325C5.87039 2.33325 3.33333 4.8703 3.33333 7.99992C3.33333 11.1295 5.87039 13.6666 9 13.6666C10.3983 13.6666 11.6784 13.1601 12.6667 12.3206M2 9.33325H8.66667M2 6.66659H8.66667" stroke="#9CA1AA" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>

);

export default EuroIcon;
